import { gql } from '@apollo/client';

import PROFILE_FRAGMENT from '@graphql/fragments/profile';

const SAVE_PROFILE = gql`
  mutation saveProfile($userId: ID!, $input: SaveProfileInput!) {
    saveProfile(userId: $userId, input: $input) {
      ...ProfileDetails
    }
  }
  ${PROFILE_FRAGMENT}
`;

export default SAVE_PROFILE;
